import React from 'react';
import {SvgIcon, useTheme} from '@mui/material';
import type {IconProps} from './types';

export const CheckboxUncheckedIcon: React.FC<IconProps> = props => {
  const {colors} = useTheme();
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <rect
        x="4.625"
        y="4.625"
        width="14.75"
        height="14.75"
        rx="3.375"
        fill={colors.offWhite}
        // Use given color (e.g. warning/error) as border, otherwise default
        stroke={props.color ? 'currentColor' : colors.warmGreen}
        strokeWidth="1.25"
      />
    </SvgIcon>
  );
};
